import { Injectable } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular';

/**
 * Holds a reference to the app's primary IonRouterOutlet (registered by MobileMenuComponent).
 * Allows AppComponent's back-button handler to call pop() directly on the outlet,
 * which is the only reliable way to navigate back within Ionic's internal view stack.
 */
@Injectable({ providedIn: 'root' })
export class RouterOutletRefService {
  private outlet: IonRouterOutlet | null = null;

  register(outlet: IonRouterOutlet): void {
    this.outlet = outlet;
  }

  canGoBack(): boolean {
    return this.outlet?.canGoBack(1) ?? false;
  }

  pop(): void {
    this.outlet?.pop();
  }
}
